import { useLocation } from 'react-router-dom';
import { getTabFromPathname } from 'utils/urls';

/**
 * React hook which returns the current tab's name
 */
export default function useTabName() {
  const { pathname } = useLocation();
  return getTabFromPathname(pathname);
}
